module.exports = __webpack_public_path__ + "static/media/gioEc_kessai.ee4daaf5.jpg";